module.exports = __webpack_public_path__ + "static/media/my-account-change-password.782e3dc0.svg";